
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IDatePlace } from 'src/app/models/location.model';

/**
 * Generated class for the DayCalendarComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'day-calendar',
  templateUrl: 'daycalendar.component.html',
  styleUrls: ['./daycalendar.component.scss'],
})
export class DayCalendarComponent implements OnInit {

  local:string = "fr-fr";
  date:Date;
  month:string;
  day:string;  
  year:string;
  dayName: string;

  @Input() multiDates:boolean = false;
  @Input() selected:boolean =false;
  @Input() clickable:boolean = false;

  _dateStr:string;
  _deliveryType:string;
  _showTime:boolean;
  deliveryTypesWithTiming = ['market','collectpoint','ownshop','pickupstore','picking'];
  _toTime:string;
  _fromTime:string;

  @Output() clicked = new EventEmitter();

  get dateStr():string{
    return this._dateStr;
  }
  @Input('dateStr') 
  set dateStr(value:string){
    if(value){
      this._dateStr = value;
      this.date = new Date(this._dateStr);
      this.month =  this.date.toLocaleString(this.local,{month:"short"});
      this.day = this.date.toLocaleString(this.local,{day:"2-digit"});
      this.year = this.date.toLocaleString(this.local,{year:"2-digit"});
      this.dayName = this.date.toLocaleString(this.local,{weekday:"short"});      
    }

  }
  @Input('dates') 
  set dates(value:IDatePlace[]){
    if(value){
      this._dateStr = value[0].date;
      this.date = new Date(this._dateStr);
      this._dates = value;
      this.month =  this.date.toLocaleString(this.local,{month:"short"});
      this.day = this.date.toLocaleString(this.local,{day:"2-digit"});
      this.year = this.date.toLocaleString(this.local,{year:"2-digit"});
      this.dayName = this.date.toLocaleString(this.local,{weekday:"short"}); 
      this.fromTimeHour =  value[0].fromTimeHour;
      this.toTimeHour =  value[0].toTimeHour;   
    }
  }
  _dates:IDatePlace[] = []

  @Input() moment:string

  @Input()
  fromTimeHour:string;
  @Input()
  toTimeHour:string; 


  get deliveryType():string{
    return this._deliveryType;
  }
  @Input('deliveryType') 
  set deliveryType(value:string){
    this._deliveryType = value;
    this._showTime = this.deliveryTypesWithTiming.includes(value);
  }

  constructor() {
  }

  ngOnInit(){
  }

  onClick(){
    this.clicked.emit();
  }

}
